import moment from 'moment'
import { setCurrency, setNumberWithPoint } from 'utils/utils'

export const TABLE_COMPARISON = [
    {
        attribute: 'Gross Sale',
        key: 'gross_sales',
    },
    {
        attribute: 'Voucher',
        key: 'voucher',
    },
    {
        attribute: 'Point',
        key: 'point',
    },
    {
        attribute: 'Net Sales',
        key: 'net_sales',
    },
    {
        attribute: 'Taxes',
        key: 'tax',
    },
    {
        attribute: 'Shipping',
        key: 'shipping',
    },
    {
        attribute: 'Total Sales',
        key: 'total_sales',
    },
]

export const TABLE_PER_DAY = {
    name: 'Revenue',
    column: [
        {
            name: 'Tanggal',
            key: 'formatted_date',
        },
        {
            name: 'Total Order',
            key: 'total_order',
            render: ({ value }) => <div>{setNumberWithPoint(value)}</div>,
        },
        {
            name: 'Gross Sales',
            key: 'gross_sales',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Voucher',
            key: 'voucher',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Point',
            key: 'point',
            render: ({ value }) => <div>{setNumberWithPoint(value)}</div>,
        },
        {
            name: 'Net Sales',
            key: 'net_sales',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Taxes',
            key: 'tax',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Shipping',
            key: 'shipping',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
        {
            name: 'Total Sales',
            key: 'total_sales',
            render: ({ value }) => <div>{setCurrency(value)}</div>,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    page: 1,
    limit: 20,
    orderBy: 'date',
    orderType: 'desc',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
}

export const SORT_REVENUE = [
    {
        label: 'Sort By Total Sales Desc',
        key: 'total-sales_desc',
        name: 'sort-revenue',
    },
    {
        label: 'Sort By Total Sales Asc',
        key: 'total-sales_asc',
        name: 'sort-revenue',
    },
    {
        label: 'Sort By Date Desc',
        key: 'date_desc',
        name: 'sort-revenue',
    },
    {
        label: 'Sort By Date Asc',
        key: 'date_asc',
        name: 'sort-revenue',
    },
]
